import { render, staticRenderFns } from "./OneOffExtrasInput.vue?vue&type=template&id=86b10236&"
import script from "./OneOffExtrasInput.vue?vue&type=script&lang=js&"
export * from "./OneOffExtrasInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports